module.exports = __webpack_public_path__ + "static/Chitty_image-bcb4c1bdb0297159ac221df636a27a7e.jpg";